module.exports = __webpack_public_path__ + "static/media/background.7dae346c.jpg";